module.exports = __webpack_public_path__ + "9768ba13770b5b3ce9a749893d493464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/2.jpg
// module id = 433
// module chunks = 0 2